import AcquisitionViewSiteNavSection from './AcquisitionViewSiteNavSection'
import HomePageSiteNavSection from './HomePageSiteNavSection'
import MinimalSiteNavSection from './MinimalSiteNavSection'
import LoggedInSiteNavSection from './LoggedInSiteNavSection'

interface SiteNavSectionProps {
  activeNavItem?: string
  classNames: any
  handleToggleNav: () => void
  showMinimalView: boolean
  showAcquisitionView: boolean
  isLoggedIn: boolean
  trackClick: (eventCta: string) => void
}

const SiteNavSection = ({
  activeNavItem,
  classNames,
  handleToggleNav,
  isLoggedIn,
  showAcquisitionView,
  showMinimalView,
  trackClick,
}: SiteNavSectionProps) => {
  if (showAcquisitionView) {
    return <AcquisitionViewSiteNavSection classNames={classNames} />
  }

  if (showMinimalView) {
    return (
      <MinimalSiteNavSection
        classNames={classNames}
        handleToggleNav={handleToggleNav}
        trackClick={trackClick}
      />
    )
  }

  if (isLoggedIn) {
    return (
      <LoggedInSiteNavSection
        activeNavItem={activeNavItem}
        classNames={classNames}
        handleToggleNav={handleToggleNav}
        trackClick={trackClick}
      />
    )
  }

  return (
    <HomePageSiteNavSection
      activeNavItem={activeNavItem}
      classNames={classNames}
      handleToggleNav={handleToggleNav}
      trackClick={trackClick}
    />
  )
}

export default SiteNavSection
